/**
 * @generated SignedSource<<819f01e000846da05daa18ff56967291>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectRecommendationType = "INVITER_ACTIVITY" | "TENANT_ACTIVITY" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type RecommendationsList$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly details: {
        readonly recommendationType: JiraProjectRecommendationType;
      } | null | undefined;
      readonly project: {
        readonly projectId: string;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"RecommendationCard_recommendation">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "RecommendationsList";
};
export type RecommendationsList$key = {
  readonly " $data"?: RecommendationsList$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecommendationsList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RecommendationsList",
  "selections": [
    {
      "concreteType": "JiraProjectRecommendationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraProjectRecommendation",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "details",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "recommendationType"
                  },
                  "action": "THROW",
                  "path": "edges.node.details.recommendationType"
                }
              ]
            },
            {
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "projectId"
                  },
                  "action": "THROW",
                  "path": "edges.node.project.projectId"
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "RecommendationCard_recommendation"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraProjectRecommendationConnection"
};

(node as any).hash = "d2c17ae8f5e6654ea9f89bf829da3e7a";

export default node;
